module.exports = __webpack_public_path__ + "static/media/student.278a2c13.png";